var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input',{staticClass:"search-bar",attrs:{"placeholder":_vm.placeholder,"prefix-icon":"el-icon-search","clearable":""},model:{value:(_vm.keywords),callback:function ($$v) {_vm.keywords=$$v},expression:"keywords"}})
}
var staticRenderFns = []

export { render, staticRenderFns }